/**
 * Garnish Illustrations (Web platform).
 * [Figma source]{@link https://www.figma.com/file/b7C0OFJIY0KwccakPwngUM/Garnish---Visual-Assets?node-id=1856%3A18}.
 *
 * To support a variety of DPI displays, all assets are exported in 3 sizes.
 * Illustrations from Figma source should be used only. For custom illustrations, please use the relative local folder.
 *
 * How to add a new image?
 *
 * 1. Export the asset from Figma in 3 sizes.
 * 2. Use a tool like TinyPNG to optimize them.
 * 3. Create an exportable variable containing an array of all those assets paths.
 *
 * Once all those steps are completed, the newly added asset can be imported from Garnish:
 *
 * import { Illus404 } from '@garnish/core';
 *
 * Make sure you follow the same process for the Native platforms (index.ts).
 *
 * @see https://developer.mozilla.org/en-US/docs/Learn/HTML/Multimedia_and_embedding/Responsive_images
 */

// ────────────────────────────────────────────────────────────────────────────────

export const Illus404 = [
  require('./Illus-404.png'),
  require('./Illus-404@2x.png'),
  require('./Illus-404@3x.png'),
];
export const IllusCredit_1 = [
  require('./Illus-Credit_1.png'),
  require('./Illus-Credit_1@2x.png'),
  require('./Illus-Credit_1@3x.png'),
];
export const IllusDelivery_1 = [
  require('./Illus-Delivery_1.png'),
  require('./Illus-Delivery_1@2x.png'),
  require('./Illus-Delivery_1@3x.png'),
];
export const IllusDressing_1 = [
  require('./Illus-Dressing_1.png'),
  require('./Illus-Dressing_1@2x.png'),
  require('./Illus-Dressing_1@3x.png'),
];
export const IllusEmployeeBag = [
  require('./Illus-EmployeeBag.png'),
  require('./Illus-EmployeeBag@2x.png'),
  require('./Illus-EmployeeBag@3x.png'),
];
export const IllusEmpty_1 = [
  require('./Illus-Empty_1.png'),
  require('./Illus-Empty_1@2x.png'),
  require('./Illus-Empty_1@3x.png'),
];
export const IllusEmpty_2 = [
  require('./Illus-Empty_2.png'),
  require('./Illus-Empty_2@2x.png'),
  require('./Illus-Empty_2@3x.png'),
];
export const IllusLocation = [
  require('./Illus-Location.png'),
  require('./Illus-Location@2x.png'),
  require('./Illus-Location@3x.png'),
];
export const IllusOutpost_1 = [
  require('./Illus-Outpost_1.png'),
  require('./Illus-Outpost_1@2x.png'),
  require('./Illus-Outpost_1@3x.png'),
];
export const IllusPickup_2 = [
  require('./Illus-Pickup_2.png'),
  require('./Illus-Pickup_2@2x.png'),
  require('./Illus-Pickup_2@3x.png'),
];
export const IllusSeasonal = [
  require('./Illus-Seasonal.png'),
  require('./Illus-Seasonal@2x.png'),
  require('./Illus-Seasonal@3x.png'),
];
export const IllusStoreOpening = [
  require('./Illus-StoreOpening.png'),
  require('./Illus-StoreOpening@2x.png'),
  require('./Illus-StoreOpening@3x.png'),
];
export const IllusSupplyChain = [
  require('./Illus-SupplyChain.png'),
  require('./Illus-SupplyChain@2x.png'),
  require('./Illus-SupplyChain@3x.png'),
];
